
import { RootState } from "redux/store";
import { useCallback, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getStockGroups, deleteStockGroup, updateStockGroupField } from "redux/slices/StockGroups";
import { Table, Title, Modal } from "components";
import { generalSync } from "redux/slices/Sync";
import { showToast } from "redux/slices/Toasts";

export function StockGroups() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const stockGroup: any = useAppSelector((state: RootState) => state.stockGroups);
	const [showPopup, setShowPopup] = useState<boolean>(false);
	const user = useAppSelector((state: RootState) => state.logedinUser);

	const columnsb = [
		{
			Header: "Name",
			accessor: "name",
			defaultCanSort: true,
			width: 1500,
			Cell: (row: any) => user.permissions.stockGroups.canUpdate ? <Link to={`/app/stock-group/${row.cell.row.original.id}`}>{row.value}</Link> : <>{row.value}</>,

		},
	];

	useEffect(() => {
		dispatch(getStockGroups());
	}, []);

	const selectedRows = useCallback((pageIndex: any) => {
		dispatch(updateStockGroupField({ key: "selectedRows", value: pageIndex }));
	}, []);

	function handleDelete() {
		let stockGroupIds = stockGroup.selectedRows.map((row: any) => stockGroup.table[row].id);
		dispatch(deleteStockGroup(stockGroupIds)).then(() => {
			dispatch(getStockGroups());
		});
	}

	function Sync() {
		dispatch(generalSync({ stockGroups: true })).then((res) => {
			if (res.data) {
				dispatch(showToast({ value: ["Sync Completed"] }))
			} else {
				dispatch(showToast({ value: ["Sync Failed"] }))
			}
		})
	}

	return (
		<>
			<Title pageTitle="Stock Groups" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSelectable={true}
										isSearchable={true}
										columns={columnsb}
										data={stockGroup.table}
										errors={stockGroup.error}
										selectedRows={selectedRows}
										loading={stockGroup.loading}
										syncOptions={() => setShowPopup(true)}
										reloadTableRows={() => dispatch(getStockGroups())}

										addNewRow={user.permissions.stockGroups.canCreate ? () => navigate("/app/stock-group/new") : undefined}
										removeRows={user.permissions.stockGroups.canDelete ? handleDelete : undefined}
									/>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			<Modal
				show={showPopup}
				title="Manual Sync"
				description="Do you want to resync all Stock Groups?"
				buttonText="Sync"
				buttonType="primary"
				handleClose={() => setShowPopup(false)}
				handleSubmit={() => {
					setShowPopup(false);
					Sync();
				}}
			/>
		</>
	);
}